import * as Colors from '../../common/colors'

const ReactSelectStyle = {
    singleValue: (styles, state) => ({
      ...styles,
      color: Colors.COLOR_TEXT_MEDIUM,
      fontWeight: state.hasValue ? 500 : 400,
    }),
    control: (styles, state) => ({
      ...styles,
      borderColor: state.isFocused ? Colors.COLOR_TEXT_EXTRA_LIGHT : styles.borderColor,
      boxShadow: state.isFocused ? 'none' : styles.boxShadow,
      '&:hover': {
        borderColor: state.isFocused ? Colors.COLOR_TEXT_EXTRA_LIGHT : styles['&:hover'].borderColor,
      },
    }),
    placeholder: (styles) => ({
      ...styles,
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '14px',
      lineHeight: '19px',
      display: 'flex',
      alignItems: 'center',
      color: '#989898',
    }),
    option: (styles, state) => ({
      ...styles,
      transition: '0.2s border-left, 0.1s background-color',
      backgroundColor: state.isSelected
        ? Colors.COLOR_GRIS_FONDO
        : state.isFocused
          ? Colors.COLOR_GRIS_FONDO
          : styles.backgroundColor,
      color: Colors.COLOR_TEXT_MEDIUM,
      fontWeight: state.isSelected ? 500 : 400,
      ':active': {
        backgroundColor: Colors.COLOR_GRIS_FONDO,
        color: Colors.COLOR_TEXT_MEDIUM,
      },
    }),
}

export default ReactSelectStyle